<template>
    <div>
        <div class="modal hide fade" id="modalSaleOrder" tabindex="-1" role="dialog" aria-labelledby="modalSaleOrder" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Template
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <table class="table table-sm table-item table-striped table-hover">
                                    <thead>
                                        <th>Template No.</th>
                                        <th>Name</th>
                                        <th>Date</th>
                                        <th>Notes</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="p in productTemplateList" :key="p.id" @click="select(p.id)" data-dismiss="modal">
                                            <td>{{ p.template_no }}</td>
                                            <td>{{ p.name }}</td>
                                            <td>{{ p.template_date }}</td>
                                            <td>{{ p.notes }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal hide fade" id="modalSaleOrderByNo" tabindex="-1" role="dialog" aria-labelledby="modalSaleOrderByNo" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Sale Order - {{ order.order_no }}
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <dl class="row">
                                    <dd class="col-sm-4"><strong>Order:</strong></dd>
                                    <dd class="col-sm-8"></dd>

                                    <dd class="col-md-4">SP No.</dd>
                                    <dd class="col-md-8"><b>{{ order.project_name }}</b></dd>

                                    <dd class="col-md-4">Tanggal</dd>
                                    <dd class="col-md-8">{{ order.order_date | dateFormat('DD/MM/YYYY') }}</dd>

                                    <dd class="col-md-4">Jatuh Tempo</dd>
                                    <dd class="col-md-8">{{ order.order_due_date | dateFormat('DD/MM/YYYY') }}</dd>

                                    <dd class="col-md-4">Salesman</dd>
                                    <dd class="col-md-8">{{ order.salesman }}</dd>
                                </dl>
                            </div>
                            <div class="col-md-6">
                                <dl class="row">
                                    <dd class="col-sm-4"><strong>Customer:</strong></dd>
                                    <dd class="col-sm-8"></dd>

                                    <dd class="col-md-4">Name</dd>
                                    <dd class="col-md-8">{{ dataCustomer.name }}</dd>

                                    <dd class="col-md-4">Phone</dd>
                                    <dd class="col-md-8">{{ dataCustomer.phone }}</dd>

                                    <dd class="col-md-4">Address</dd>
                                    <dd class="col-md-8">{{ dataCustomer.address }}</dd>
                                </dl>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-item table-sm table-hover table-striped">
                                        <thead>
                                            <th>Product No.</th>
                                            <th>Product</th>
                                            <th>Qty</th>
                                            <th>Qty Done</th>
                                            <th>Qty Remaining</th>
                                            <th>Uom</th>
                                            <th class="text-right">Price</th>
                                            <th class="text-right">Discount</th>
                                            <th class="text-right">Subtotal (DPP)</th>
                                            <th class="text-right">Tax</th>
                                            <th class="text-right">Total</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="d in order.details" :key="d.id">
                                                <td>{{ d.product_no }}</td>
                                                <td>{{ d.description }}</td>
                                                <td>{{ d.qty }}</td>
                                                <td>{{ d.qty_done }}</td>
                                                <td>{{ d.qty - d.qty_done }}</td>
                                                <td>{{ d.uom_id }}</td>
                                                <td class="text-right">{{ d.price | currency }}</td>
                                                <td>{{ d.discount_percentage }}%</td>
                                                <td class="text-right">{{ d.subtotal | currency }}</td>
                                                <td class="text-right">{{ d.tax | currency }}</td>
                                                <td class="text-right">{{ d.total | currency }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="9"></td>
                                                <td class="text-right"><b>Subtotal</b></td>
                                                <td class="text-right">{{ totalSubtotalOrderDetail | currency }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="9"></td>
                                                <td class="text-right"><b>Discount</b></td>
                                                <td class="text-right">({{ totalDiscountOrderDetail | currency }})</td>
                                            </tr>
                                            <tr>
                                                <td colspan="9"></td>
                                                <td class="text-right"><b>Tax</b></td>
                                                <td class="text-right">{{ totalTaxOrderDetail | currency }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="9"></td>
                                                <td class="text-right"><b>Total</b></td>
                                                <td class="text-right">{{ totalOrderDetail | currency }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- <pre>{{ order }}</pre> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="modal hide fade" id="modalSalesOrderList" tabindex="-1" role="dialog" aria-labelledby="modalSalesOrderList" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Order List
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <div class="alert alert-info" role="alert">
                                <i class="fa fa-info-circle font-24" aria-hidden="true"></i> <b>Order</b> harus di <b>Approve</b> sebelum dapat dilakukan proses <b>penjualan</b>
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <table class="table table-sm table-item table-hover table-striped">
                                <thead>
                                    <th>
                                        <label class="form-checkbox"><input type="checkbox" v-model="selectAll" @click="selectList"><i class="form-icon"></i></label>
                                    </th>
                                    <th>Status</th>
                                    <th>Order No.</th>
                                    <th>Salesman</th>
                                    <th>SP No.</th>
                                    <th>Date</th>
                                    <th>Due Date</th>
                                    <th class="text-right">Total</th>
                                </thead>
                                <tbody>
                                    <tr v-for="c in customerOrderList" :key="c.id">
                                        <td>
                                            <label class="form-checkbox">
                                                <input type="checkbox" :value="c.id" v-model="selected"><i class="form-icon"></i>
                                            </label>
                                        </td>
                                        <td>
                                            <span v-if="c.status === 'order'" class="badge badge-warning">{{ c.status }}</span>
                                            <span v-else-if="c.status === 'approved'" class="badge badge-primary">{{ c.status }}</span>
                                        </td>
                                        <td>{{ c.order_no }}</td>
                                        <td>{{ c.salesman }}</td>
                                        <td><b>{{ c.project_name }}</b></td>
                                        <td>{{ c.order_date | dateFormat('DD/MM/YYYY') }}</td>
                                        <td>{{ c.order_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                        <td class="text-right">{{ c.total | currency }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-hard-primary" data-dismiss="modal" @click="selectOrder">Select</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SaleOrderModal',
  data () {
    return {
      selectAll: false,
      selected: []
    }
  },
  computed: {
    ...mapState({
      productTemplateList: state => state.products.productTemplateList,
      order: state => state.sales.order,
      customerOrderList: state => state.customers.customerOrderList
    }),
    totalOrderDetail () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalDiscountOrderDetail () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].discount) * parseFloat(array[i].qty)
      }
      return sum
    },
    totalTaxOrderDetail () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax) * parseFloat(array[i].qty)
      }
      return sum
    },
    totalSubtotalOrderDetail () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].subtotal) * parseFloat(array[i].qty)
      }
      return sum
    },
    dataCustomer () {
      var customer = this.order.customer
      var obj
      if (typeof customer === 'undefined') {
        obj = {
          name: null,
          phone: null,
          address: null
        }
      } else {
        obj = {
          name: customer.name,
          phone: customer.phone,
          address: customer.address
        }
      }
      return obj
    }
  },
  methods: {
    selectOrder () {
      var loop = []
      var array = this.selected
      for (let i = 0; i < array.length; i++) {
        loop.push(this.customerOrderList.find(d => d.id === array[i]))
      }
      this.selected = []
      this.$emit('selectOrderMulti', loop)
    },
    selectList: function () {
      this.selected = []
      if (!this.selectAll) {
        for (const i in this.customerOrderList) {
          this.selected.push(this.customerOrderList[i].id)
        }
      }
    },
    select: function (id) {
      var temp = this.productTemplateList.find(d => d.id === id)
      this.$emit('selectTemplate', temp)
    }
  }
}
</script>
